import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
const {makeAuthenticatedGETRequest} = require('../../utils/endPointCalling');

function ProfileCard({item, viewDetails}) {
  const [checkSaved, setCheckSaved] = useState([]);

  const increaseViews = async () => {
    const response = await makeAuthenticatedGETRequest('/feature/views/'+item._id);
}

  const getData = async () => {
    const response = await makeAuthenticatedGETRequest('/feature/get/saved/only');
    setCheckSaved(response.data.saved);
  }

  const saveUser = async () => {
    const response = await makeAuthenticatedGETRequest('/feature/save/user/'+item._id);
    if(response && !response.err){
      toast.success('User Saved Successfully');
      await getData();
    }
  }
  const removeUser = async () => {
    const response = await makeAuthenticatedGETRequest('/feature/remove/user/'+item._id);
    if(response && !response.err){
      toast.success('User Removed Successfully');
      await getData();
    }
  }
  useEffect(()=>{
    getData();
  },[]);
  return (
    <div style={{backgroundColor: '#D4BBDD'}} className=' flex flex-col justify-start p-[2vmax] rounded-[0.5vmax] my-[0.8vmax] text-black'>
        <div className='text-[2.2vmax] font-bold'>{item.name}</div>
        <div className='text-[1.5vmax]'><span className='font-semibold'>Email:</span>{" "+item.email}</div>
        <div className='text-[1.5vmax]'><span className='font-semibold'>Phone Number:</span>{" "+item.phoneNumber}</div>
        <div className='text-[1.5vmax]'><span className='font-semibold'>Department:</span>{" "+item.department}</div>
        <div className='text-[1.5vmax]'><span className='font-semibold'>Languages Known:</span>{" "+item.languagesKnown}</div>
        <div className='text-[1.5vmax]'><span className='font-semibold'>Permanent State:</span>{" "+item.permanentState}</div>
        <div className='text-[1.5vmax]'><span className='font-semibold'>Current State:</span>{" "+item.currentState}</div>
        <div className='flex w-full justify-center items-center gap-[0.8vmax]'><button style={{backgroundColor: '#5E376D'}} onClick={(e)=>{
            e.preventDefault();
            viewDetails();
            increaseViews();
        }} className='bg-white w-1/2 text-white rounded-[0.5vmax] font-bold text-[1.3vmax] my-[1vmax]'>View Details</button>
        <button onClick={(e)=>{
            e.preventDefault();
            if(checkSaved.includes(item._id)){
              removeUser();
            }
            else {
              saveUser();
            }
        }} style={{backgroundColor: '#5E376D'}} className='bg-white w-1/2 text-white rounded-[0.5vmax] font-bold text-[1.3vmax] my-[1vmax]'>{checkSaved.includes(item._id) ? 'Remove' : 'Save'}</button></div>
    </div>
  )
}

export default ProfileCard